<template>
  <div class="admin_company_modal">
    <UeGlobalModal
      name="admin_company_modal"
      width="50%"
      title="Associate Company With Domain"
      @before-open="beforeOpen"
      ref="companyModal"
    >
      <div class="card">
        <div class="card-header">
          <ul class="nav nav-tabs card-header-tabs">
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'existing' }"
                href="#"
                @click.prevent="activeTab = 'existing'"
              >
                Search Existing Company
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                :class="{ active: activeTab === 'new' }"
                href="#"
                @click.prevent="activeTab = 'new'"
              >
                Create a new company
              </a>
            </li>
          </ul>
        </div>
        <div class="card-body">
          <div v-if="activeTab === 'existing'">
            <div class="mb-3">
              <CompanySelector v-model="company_id" />
            </div>
            <div class="mb-3">
              <button type="button" class="btn btn-primary" @click="saveExistingCompany">
                Save
              </button>
            </div>
          </div>
          <div v-if="activeTab === 'new'">
            <div class="form-group mb-3">
              <label for="company-name">Company name</label>
              <input type="text" class="form-control" id="company-name" v-model="company.name" />
            </div>
            <div class="form-group mb-3">
              <label for="sub-industry">Choose an Industry</label>
              <SubIndustrySelector v-model="company.sub_industry_id" />
            </div>
            <div class="form-group mb-3">
              <p>How big is the company?</p>
              <select class="form-control" v-model="company.size_group">
                <option v-for="option in sizeGroupings" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>
            <button type="button" class="btn btn-primary" @click="saveNewCompany">Save</button>
          </div>
        </div>
      </div>
    </UeGlobalModal>
  </div>
</template>

<script lang="ts">
import axios from '@lib/apiClient'
import SubIndustrySelector from '@/survey/components/SubIndustrySelector.vue'
import CompanySelector from '@/admin/components/CompanySelector.vue'
import UeGlobalModal from '@components/base/UeGlobalModal.vue'

export default {
  components: { SubIndustrySelector, CompanySelector, UeGlobalModal },
  data() {
    return {
      activeTab: 'existing',
      domain_id: null,
      company_id: null,
      company: {
        name: null,
        sub_industry_id: null,
      },
      sizeGroupings: [
        { value: 'small_business', text: 'Small Business (1-50)' },
        { value: 'medium_enterprise', text: 'Medium Enterprise (50-1000)' },
        { value: 'large_enterprise', text: 'Large Enterprise (1000+)' },
        { value: 'fortune_500', text: 'Fortune 500' },
      ],
    }
  },
  methods: {
    saveNewCompany() {
      axios
        .post(`/admin/api/companies.json`, {
          company: Object.assign(this.company, { ue_verified: true }),
        })
        .then((r) => {
          axios
            .patch(`/admin/api/domains/${this.domain_id}.json`, {
              domain: { company_id: r.data.company.id },
            })
            .then(() => {
              this.$toast('Company Saved')
              this.$refs.companyModal.hide()
            })
        })
    },
    saveExistingCompany() {
      axios
        .patch(`/admin/api/domains/${this.domain_id}.json`, {
          domain: {
            company_id: this.company_id,
          },
        })
        .then(() => {
          this.$toast('Company Updated')
          this.$refs.companyModal.hide()
        })
    },
    beforeOpen(e) {
      this.domain_id = e.params
      this.activeTab = 'existing' // Reset to first tab when opening
    },
  },
}
</script>
